// Search definition para o modal de busca de Purchase Orders (Ordens de Compra de Importação).
// Endpoint: PurchaseOrdersController.GetAll (GET /PurchaseOrders).
// A busca textual (query param 'busca') cobre: NomeReferencia, NumeroPurchaseOrder e
// NomeFantasia do fornecedor (ver PurchaseOrdersController.GetAll).
// A coluna LstStatusPurchaseOrder exige 'tabela' para resolução via DicionarioMetadadosListas
// (mapeamento: PurchaseOrder.LstStatusPurchaseOrder → PO_ST / Cliente).
//
// Segue a diretriz FRONTEND/11-search-definitions.md:
//  - label e placeholder obrigatórios
//  - displayField/descField explícitos
//  - tabela obrigatória por haver campo Lst* no colunasGrid

export const criarConfigBuscaPurchaseOrder = (idOrganizacao, lstStatus = null) => ({
  label: 'Purchase Order',
  placeholder: 'Referência ou Nº da PO...',
  titulo: 'Buscar Purchase Order',
  endpointApi: 'PurchaseOrders',
  idField: 'idPurchaseOrder',
  displayField: 'nomeReferencia',
  descField: 'nomeReferencia',
  tabela: 'PurchaseOrder',
  camposFiltro: [
    { label: 'Referência / Nº PO', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idPurchaseOrder', width: '8%' },
    { header: 'Referência', dataField: 'nomeReferencia', width: '25%' },
    { header: 'Nº PO', dataField: 'numeroPurchaseOrder', width: '15%' },
    { header: 'Fornecedor', dataField: 'nomeFornecedor', width: '25%' },
    { header: 'Status', dataField: 'lstStatusPurchaseOrder', width: '15%' },
    { header: 'Emissão', dataField: 'dataEmissao', width: '12%' }
  ],
  filtrosFixos: {
    idOrganizacao,
    ...(lstStatus ? { lstStatus } : {})
  }
})
